const SliderArrow = (props) => {

    const {classNames, style, onClick} = props;

    return (
        <div
          className={classNames}
          style={{...style}}
          onClick={onClick}
        />
    );
};

export default SliderArrow;